<div class="codex-main-container">
    <div *ngIf="currentReport" class="select-codex-view-container">
        <a *ngIf="userRoleWorkspacePriority >= 30" class="go-back-btn" routerLink="/codex">
            <i class="bi bi-chevron-left"></i>
            <span>{{ 'report_back_to_all_teams' | translate }}</span>
        </a>
        <div class="td-view-switch">
            <button type="button" class="td-view-switch-btn" [ngClass]="{'active': codexView === 'quarter'}"
                    (click)="setCodexView('quarter')">
                <i class="bi bi-calendar3"></i>
                <span>{{ 'codex_quarter_view' | translate }}</span>
            </button>
            <button type="button" class="td-view-switch-btn" [ngClass]="{'active': codexView === 'indicator'}"
                    (click)="setCodexView('indicator')">
                <i class="bi bi-bar-chart"></i>
                <span>{{ 'codex_indicator_view' | translate }}</span>
            </button>
        </div>
    </div>
    <div *ngIf="currentReport" class="codex-components-container">
        <app-codex-quarter-view *ngIf="currentReport && codexView === 'quarter'"
            [currentQuarter]="currentReport"
            [quarterList]="teamCodexReports"
            [teamNameToDisplay]="selectedCodexTeamName"
            (emitQuarterChange)="onReportChange($event)"
            (emitSortingChange)="sortQuarterQuestions($event)"
            (emitTeamRouting)="goBackToTeam()">
        </app-codex-quarter-view>
        <app-codex-indicator-view *ngIf="currentReport && showCategoryStatements && codexView === 'indicator'"
            [currentReport]="currentReport"
            [codexesByCategory]="codexesByCategory"
            (indicatorChanges)="questionCategoryChanged($event)">
        </app-codex-indicator-view>
    </div>
</div>
